export enum IncomingInvoiceErrorMessageEnum {
  MISMATCHED_DELIVERY_COSTS = 'Mismatched delivery costs.',
  MISMATCHED_DELIVERY_COSTS_DE = 'Lieferkosten stimmen nich überein.',
  MISMATCHED_QUANTITY = 'Mismatched quantity.',
  MISMATCHED_QUANTITY_DE = 'Die Menge stimmt nich überein.',
}

export enum IncomingInvoiceErrorNameEnum {
  MISMATCHED_AMOUNT_DECISION = 'mismatchedAmountDecision',
  MISMATCHED_AMOUNT = 'mismatchedAmount',
  QUANTITY_MISMATCH = 'quantityMismatch',
  MISMATCH_TEXTRACT_AMOUNT = 'MISMATCH_TEXTRACT_AMOUNT',
}
